import * as utils from 'utils';
import { i18n } from 'services';

export const isEmail = (value: string | undefined) => {
  if (!value) {
    return undefined;
  }
  return utils.isEmail(value) ? undefined : i18n.t('formValidationErrors.isEmail');
};
